import * as React from 'react'

const MoreDetails = () => {
    return (
        <div id="more-detail1">
            <div className="container">
            <div className="row">
                <div className="col-md-4 p-4">
                <div className="border-right-line">
                    <h4>15,000+ Happy Customers</h4>
                    <p>
                    Many customers purchase our products ever year. Folks
                    have begun and retired from their advocacy careers with
                    our products in their pockets.
                    </p>
                </div>
                </div>
                <div className="col-md-4 p-4">
                <div className="border-right-line">
                    <h4>Nearly 50 Years In Business</h4>
                    <p>
                    Proven, accurate, reliable, and indespensible. Capitol
                    Enquiry products have empowered advocacy since 1973.
                    </p>
                </div>
                </div>
                <div className="col-md-4 p-4">
                <div className="border-right-line no-border">
                    <h4>Federal, State & Local Solutions</h4>
                    <p>
                    We operate a USA based call center and use proprietary
                    software to collect the most up to date data possible.
                    </p>
                </div>
                </div>
            </div>
            </div>
        </div>
    )
}

export default MoreDetails
